import keyMirror from 'react-utils/keyMirror';
export const ALIGNMENT_OPTIONS = keyMirror({
  left: null,
  center: null,
  right: null
});
export const defaultImage = 'final/img/content/email-template-images/placeholder_200x200.png';